// extracted by mini-css-extract-plugin
export default {"preview_controls_text":"PreviewControls-module_preview_controls_text___H7EE","iframe_loading_spinner":"PreviewControls-module_iframe_loading_spinner__c73Y8"};